import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import Cart from '../../../shared-components/Cart/Cart';
import _ from 'lodash';

const LOCALE_PREFIX = 'GB/components/Header/Header';

export class Header extends Component {

    static propTypes = {
        cartAmount: PropTypes.string,
        intl: intlShape.isRequired,
        userLoggedIn: PropTypes.bool,

        // Passed in props
        displayLogout: PropTypes.bool,
        paypalLogo: PropTypes.bool,
        singleColumnLayout: PropTypes.bool
    };

    static defaultProps = {
        displayLogout: false,
        paypalLogo: false,
        singleColumnLayout: false
    };

    render() {
        const { intl, cartAmount, singleColumnLayout, paypalLogo, userLoggedIn, displayLogout } = this.props;
        const isTransactional = (cartAmount && cartAmount != '0'); //TODO must be some better logic than this?

        return (
            <header>
                <div className="row-fluid">
                    <div className={singleColumnLayout ? 'span24' : 'span14'}>
                        <div id="cue-header" className="clearfix section-border-bottom">
                            <div id="cue-header-left" className="pull-left vertical-middle">
                                {paypalLogo ? <div id="cue-paypal-icon" /> : <div className="ppcredit-logo" />}
                            </div>
                            <div id="cue-header-right" className="pull-right vertical-middle">
                                {isTransactional && <Cart />}
                                {displayLogout && userLoggedIn && (
                                    <a id="logout"
                                        data-automation-id="logout"
                                        href="/ppcreditapply/logout"
                                    >
                                        {intl.formatMessage({
                                            id: `${LOCALE_PREFIX}.log-out`
                                        })}
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

export const mapStateToProps = state => {
    return {
        cartAmount: _.get(state, 'serverData.cart.subtotal'),
        userLoggedIn: state.serverData.userLoggedIn
    };
};

export default connect(mapStateToProps)(injectIntl(Header));
